import { reviews, messages as reviewsMessages } from './data/reviews';
import { sections, messages as toolsMessages } from './data/tools';
import MentalHealthTools from './MentalHealthTools';
import { AdditionalContentWrapper, GradientBg } from './styles';
import Testimonials from './Testimonials';
import ValueProps from './ValueProps';

const AdditionalContent = () => {
	return (
		<>
			<AdditionalContentWrapper>
				<ValueProps />
				<GradientBg>
					<MentalHealthTools
						toolsSections={sections}
						toolsHeading={toolsMessages.heading}
						toolsCopy={toolsMessages.copy}
					/>
					<Testimonials reviews={reviews} reviewsHeading={reviewsMessages.reviewsHeading} />
				</GradientBg>
			</AdditionalContentWrapper>
		</>
	);
};

export default AdditionalContent;
